import IconButton from './IconButton';

export * from './IconButton.theme';

export default IconButton;
